var video_block = document.querySelector('.block-video-embed');

document.addEventListener("DOMContentLoaded", function () {

    if(video_block){
        bindTriggers();     
    }

    

});

function init_video_block(){
    let first = video_block.querySelectorAll('.video-titles a')[0];
    first.click();
}

function bindTriggers(){
    let video_embed_triggers = video_block.querySelectorAll('.video-titles a');
    video_embed_triggers.forEach(function(trigger){
        trigger.addEventListener('click', function(event){
            event.preventDefault();
            resetEmbeds(); //reset

            let id = this.dataset.toggle;
            let embed = video_block.querySelector('[data-embed-id="' + id + '"]');
            this.closest("li").classList.add("active");
            embed.classList.add("show");
        });
    });

     init_video_block();
}

function resetEmbeds(){
    let video_embeds = video_block.querySelectorAll('[data-embed-id]');
    video_embeds.forEach(function(embed){
        embed.classList.remove("show");
    });

    let video_embed_triggers = video_block.querySelectorAll('.video-titles a');
    video_embed_triggers.forEach(function(trigger){
        trigger.closest("li").classList.remove("active");
    });
}